// Header - Main navigation header
import { Group, Button, Text, Menu, Avatar, UnstyledButton } from '@mantine/core';
import {
  IconLogout,
  IconUser,
  IconSettings,
  IconDashboard,
  IconUsers,
  IconChartBar,
  IconPlug,
  IconBell,
  IconRobot,
} from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants/routes';

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <Group h="100%" px="md" justify="space-between">
      {/* Logo and Navigation */}
      <Group gap="xl">
        <Text
          size="xl"
          fw={700}
          style={{ color: '#2196f3', cursor: 'pointer' }}
          onClick={() => navigate(ROUTES.DASHBOARD)}
        >
          CarLeads
        </Text>
        <Group gap="xs">
          <Button
            variant={isActive(ROUTES.DASHBOARD) ? 'light' : 'subtle'}
            leftSection={<IconDashboard size={16} />}
            onClick={() => navigate(ROUTES.DASHBOARD)}
            size="sm"
          >
            Dashboard
          </Button>
          <Button
            variant={isActive(ROUTES.LEADS) ? 'light' : 'subtle'}
            leftSection={<IconUsers size={16} />}
            onClick={() => navigate(ROUTES.LEADS)}
            size="sm"
          >
            Leads
          </Button>
          <Button
            variant={isActive(ROUTES.ANALYTICS) ? 'light' : 'subtle'}
            leftSection={<IconChartBar size={16} />}
            onClick={() => navigate(ROUTES.ANALYTICS)}
            size="sm"
          >
            Analytics
          </Button>
          <Button
            variant={isActive(ROUTES.INTEGRATIONS) ? 'light' : 'subtle'}
            leftSection={<IconPlug size={16} />}
            onClick={() => navigate(ROUTES.INTEGRATIONS)}
            size="sm"
          >
            Integrations
          </Button>
          <Button
            variant={isActive(ROUTES.NOTIFICATIONS) ? 'light' : 'subtle'}
            leftSection={<IconBell size={16} />}
            onClick={() => navigate(ROUTES.NOTIFICATIONS)}
            size="sm"
          >
            Notifications
          </Button>
          <Button
            variant={isActive(ROUTES.SCRAPERS) ? 'light' : 'subtle'}
            leftSection={<IconRobot size={16} />}
            onClick={() => navigate(ROUTES.SCRAPERS)}
            size="sm"
          >
            Scrapers
          </Button>
        </Group>
      </Group>

      {/* User menu */}
      <Menu shadow="md" width={200}>
        <Menu.Target>
          <UnstyledButton>
            <Group gap="xs">
              <Avatar color="blue" radius="xl" size="sm">
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
              <Text size="sm" fw={500}>
                {user?.name}
              </Text>
            </Group>
          </UnstyledButton>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>Account</Menu.Label>
          <Menu.Item
            leftSection={<IconUser size={14} />}
            onClick={() => navigate(ROUTES.SETTINGS_PROFILE)}
          >
            Profile
          </Menu.Item>
          <Menu.Item
            leftSection={<IconSettings size={14} />}
            onClick={() => navigate(ROUTES.SETTINGS)}
          >
            Settings
          </Menu.Item>

          <Menu.Divider />

          <Menu.Item
            color="red"
            leftSection={<IconLogout size={14} />}
            onClick={logout}
          >
            Logout
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
